export default __webpack_public_path__ + "static/media/listImage.5953aec7.svg";